import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { contactsApi } from 'src/Services/API';

const useFetchContact = (contactId?: string) => {
  const assetId = useCurrentAssetId();

  return useQuery({
    queryKey: ['fetch-contact', assetId, contactId],
    queryFn: async () => {
      if (!contactId) throw new Error('Contact id not provided');
      if (!assetId) throw new Error('No assetId provided');

      return (await contactsApi.contactsControllerFindOne(contactId, assetId)).data;
    },
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    enabled: !!contactId && !!assetId,
  });
};

export default useFetchContact;
